import React from "react";
import "./ServicesPage.css";
import { Link } from "react-router-dom";

const services = [
  {
    title: "תיקון גגות",
    desc: "תיקון גגות בזפת או ביריעות אלומיניום",
    img: "/7.jpeg",
    path: "/Roofrepair",
  },
  {
    title: "איתור נזילות",
    desc: "  איתור נזילות על ידי אנשי מקצוע ",
    img: "/6.jpeg",
        path: "/Leak_detection",
  },
  {
    title: "איטום קירות חיצוניים",
    desc: " איטום קירות חיצוניים בסנפלינג  ",
    img: "/5.jpeg",
        path: "/Sealingexteriorwalls",

  },
  {
    title: "זיפות גגות",
    desc: " איטום וזיפות גגות נעשה רק על ידי מומחים!  ",
    img: "/10.jpeg",
        path: "/Rooftarps",
  },
  {
    title: "יריעות ביטומניות",
    desc: " איטום הגג ביריעות ביטומניות   ",
    img: "/9.jpeg",
        path: "/Bituminoussheets",
  },
  {
    title: "עבודה בגובה",
    desc: " ,   איטום קירות חיצוניים, איתור נזילות, איטום ותיקון גגות רעפים, שיקום מבנים ועוד",
    img: "/8.jpeg",
        path: "/Working_at_Height",
  },
];

export default function ServicesPage() {
  return (
    <div className="services-page">

      <h1 className="page-title">השירותים שלנו</h1>

      <div className="services-grid">
        {services.map((item, index) => (

            <Link to={item.path} key={index} className="service-card">


     
            
            <div className="img-wrapper">
              <img src={item.img} alt={item.title} />
            </div>

            <h3>{item.title}</h3>
            <p>{item.desc}</p>

            <button>לפרטים נוספים</button>

        
                      </Link>
          
        ))}
      </div>

    </div>
  );
}